export const APP_NAME = 'deal-history';

export const DEAL_HISTORY_ROUTE_ROOT = '/dealHistory';
